/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * Copyright IBM Corp. 2017
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'baglass/core-client/js/core-client/ui/properties/PropertyTabView',
	'lodash'
], function(PropertyTabView, _) {
	'use strict';

	const BaseTab = PropertyTabView.extend({

		init(options) {
			BaseTab.inherited('init', this, arguments);
			_.extend(this, options);
		},

		render() {
			return this.renderPropertyUIControl({
				'glassContext': this.glassContext,
				'el': this.$el,
				'items': this.items
			});
		}
	});

	return BaseTab;
});
